import React from 'react';
import { motion } from 'framer-motion';

const ClientLogos: React.FC = () => {
  // Placeholder logos - in a real implementation, these would be imported images
  const logos = [
    { id: 1, name: 'Client 1' },
    { id: 2, name: 'Client 2' },
    { id: 3, name: 'Client 3' },
    { id: 4, name: 'Client 4' },
    { id: 5, name: 'Client 5' },
  ];

  return (
    <div className="bg-black py-16">
      <div className="container mx-auto px-4">
        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-2xl font-semibold text-center mb-12"
        >
          We've worked with
        </motion.h2>
        
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16">
          {logos.map((logo, index) => (
            <motion.div
              key={logo.id}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="w-24 h-24 bg-gray-800 rounded-full flex items-center justify-center grayscale hover:grayscale-0 transition-all duration-300"
            >
              <span className="text-gray-400">{logo.name}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ClientLogos;
